import styled from "styled-components";

export const FreeToPlayIconPositionDefaultBox = styled.div<{bottomNavbarHeight: number; shouldOffsetIcon: boolean;}>`
    position: fixed;
    z-index: 4;
    right: 0;    
    width: 150px;
    bottom: ${props => (props.bottomNavbarHeight === 0 ? "env(safe-area-inset-bottom)" : (props.bottomNavbarHeight + "px"))};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 130px;
    }
`;
